// app/javascript/controllers/tom_select_controller.js
import { Controller } from "@hotwired/stimulus"
// import "tom-select/dist/js/tom-select.complete.js"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    allowCreate: { type: Boolean, default: true }
  }

  connect() {
    if (this.element.tomselect) return

    this.tomSelect = new window.TomSelect(this.element, {
      plugins: ["remove_button"],
      create: this.allowCreateValue,
      persist: false,
      maxItems: null,
      controlInput: '<input autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">'
    })
  }

  disconnect() {
    this.tomSelect?.destroy()
  }
}
